import { ChangeDetectorRef } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { interval, Observable, of } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { BaseFormComponent, keys } from '@sim/form';
import { FormManagerService } from '@sim/form/services/form-manager.service';


export abstract class BaseGuardFormComponent<T> extends BaseFormComponent<T> {

  abstract readonly activatedTabs: Record<number, boolean>;

  get activeTabIndex() {
    return this.route.snapshot.queryParams.tab || 0;
  }

  constructor(
    protected readonly snackBarService: MatSnackBar,
    protected readonly translate: TranslateService,
    protected readonly route: ActivatedRoute,
    protected readonly formManager: FormManagerService,
    // TODO: Allow to set a generic spinner with an Adapter interface as Material do for DateAdapter
    protected readonly spinner: NgxSpinnerService,
    protected readonly router: Router,
    protected readonly cd: ChangeDetectorRef,
    protected readonly formMeta?: any, // FIXME: Improve type
    protected readonly formEditDataExtractor: (id?: string) => Observable<T | undefined> = () => of(undefined),
    protected readonly indexResourcePath?: string,
    protected readonly queryParams = {},
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      cd,
      formMeta,
      formEditDataExtractor,
      indexResourcePath,
      router,
      queryParams,
    );

    interval(3000).pipe(
      tap(() => {
        const falseIndex = keys(this.activatedTabs).find((key) => this.activatedTabs[key] === false);
        if (falseIndex) {
          this.activatedTabs[falseIndex] = true;
          this.cd.markForCheck();
        }
      }),
      takeUntil(this.onDestroy$),
    ).subscribe();
  }

  tabChangeHandler(data: { index: number }) {
    this.activatedTabs[data.index] = true;

    this.router.navigate(['./'], { relativeTo: this.route, queryParams: { tab: data.index }, queryParamsHandling: 'merge' });
  }
}
